import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Template from './template';
import {
  ArrangeLicense,
  BusinessRegistration,
  IndemnityInsurance,
  TransportationLicense,
} from 'components';
import { apiGetServiceInfo } from 'api/ZimssaAPI';
import { useApiRequest } from 'hooks';
import { useParams } from 'react-router-dom';

function CertInfoView(): React.ReactElement {
  const [certInfo, setCertInfo] = useState<CerInfoProps>(defaultProps);
  const { serviceType, serviceIdx, certName } = useParams<{ serviceType: string, serviceIdx: string, certName: string }>();
  const [fetchResult, fetchServiceInfo] = useApiRequest<any>(apiGetServiceInfo);

  useEffect(() => {
    if (certName && serviceType && serviceIdx) {
      fetchServiceInfo({
        type: 'REQUEST',
        body: [serviceType, serviceIdx],
      });
    }
  }, [fetchServiceInfo, certName, serviceType, serviceIdx]);

  useEffect(() => {
    if (certName && serviceType) {
      const { result, data, message } = fetchResult;
      if (result === 'success' && data) {
        if (
          serviceType === 'smallmove' ||
          serviceType === 'familymove' ||
          serviceType === 'move_cleaning'
        ) {
          setCertInfo({
            businessRegistrationNumber: data.service.businessRegistrationNumber,
            businessRegistrationImage: data.service.businessRegistrationImage,
            businessRegistrationOwner: data.service.businessRegistrationOwner,
            familyRelationImage: data.service.familyRelationImage,
            taxClassification: data.service.taxClassification,

            arrangeLicenseImage:
              serviceType === 'familymove'
                ? data.familyMove.arrangeLicenseImage
                : '',
            indemnityInsuranceImage:
              serviceType === 'familymove'
                ? data.familyMove.indemnityInsuranceImage
                : '',

            transportationLicenseNumber:
              serviceType === 'smallmove'
                ? data.smallMove.transportationLicenseNumber
                : '',
            transportationLicenseImage:
              serviceType === 'smallmove'
                ? data.smallMove.transportationLicenseImage
                : '',
          });
        }
      } else {
        if (message) alert(message);
      }
    }
  }, [fetchResult, certName, serviceType]);

  const getCertInfoCallback = useCallback((): React.ReactElement => {
    switch (certName) {
      case 'arrangelicense':
        return <ArrangeLicense {...certInfo} />;
      case 'businessregistration':
        return <BusinessRegistration {...certInfo} />;
      case 'indemnityinsurance':
        return <IndemnityInsurance {...certInfo} />;
      case 'transportationlicense':
        return <TransportationLicense {...certInfo} />;
      default:
        return <Fragment></Fragment>;
    }
  }, [certInfo, certName]);

  return <Template>{getCertInfoCallback()}</Template>;
}

export default CertInfoView;

interface CerInfoProps {
  // 사업자 등록
  businessRegistrationNumber: string; // 사업자등록 번호
  businessRegistrationImage: string; // 사업자등록증 사진
  businessRegistrationOwner: string; // 사업자 명의
  familyRelationImage: string; // 가족관계 증명서
  taxClassification: string; // 과세정보

  // 가정이사
  arrangeLicenseImage: string; // 화물 자동차 운송 주선사업 허가증
  indemnityInsuranceImage: string; // 이사화물 배상 책임 보험

  // 소형이사
  transportationLicenseNumber: string; // 화물운송 종사자 자격명 번호
  transportationLicenseImage: string; // 화물운송 종사자 자격증명 사진
}

const defaultProps: CerInfoProps = {
  businessRegistrationNumber: '',
  businessRegistrationImage: '',
  businessRegistrationOwner: '',
  familyRelationImage: '',
  taxClassification: '',
  arrangeLicenseImage: '',
  indemnityInsuranceImage: '',
  transportationLicenseNumber: '',
  transportationLicenseImage: '',
};
